import httpService from "../httpService";

export default {
  findAll() {
    return httpService.get("/hcCfgPosition");
  },
}



// WEBPACK FOOTER //
// ./src/services/maybay/hcCfgPositionService.js